/* eslint-disable react/jsx-no-bind */
import React, { lazy } from 'react';
import ApiPage from '../pages/ApiPage/containers/ApiPage';
import { generateMultipleRoutes, generateRoutes } from './RoutesHelpers';
import CustomiseEditorPage from '../pages/CustomiseEditorPage/containers/CustomiseEditorPage';
import SettingsPage from '../pages/SettingsPage/containers/SettingsPage';
import TeamGroupsPage from '../pages/TeamGroupsPage/containers/TeamGroupsPage';
import TeamMembersPage from '../pages/TeamMembersPage/containers/TeamMembersPage';
import TeamWebhooksPage from '../pages/TeamWebhooksPage/containers/TeamWebhooksPage';
import AnalyticsPage from '../pages/AnalyticsPage/containers/AnalyticsPage';
import ThemesPage from '../pages/ThemesPage/containers/ThemesPage';
import config from '../config';
import { Redirect, Route } from 'react-router-dom';

const ChartsPage = lazy(() => import('../pages/ProjectsPage/containers/ProjectsPage'));
const SubscriptionPage = lazy(() => import('../pages/SubscriptionPage/SubscriptionPage'));
const LayoutEditor = lazy(() => import('../pages/LayoutEditorPage/containers/LayoutEditor'));
const TableEditor = lazy(() => import('../pages/TableEditorPage/containers/TableEditor'));

export default function (props) {
  const { user, teams, team, subscription, paths, loading, openNewDivisionModal, setNavActions, toggleMenu } = props;

  const profilePages = generateMultipleRoutes(
    user,
    teams,
    team,
    toggleMenu,
    loading,
    paths,
    [
      {
        render: (props) => <ChartsPage deleted={props.match.params.filter === 'deleted'} {...props} />,
        path: paths.profileCharts + '/:filter?'
      },
      {
        render: (props) => <TeamMembersPage addDivision={openNewDivisionModal} {...props} />,
        path: paths.profileTeamMembers
      },
      {
        render: (props) => <TeamGroupsPage {...props} />,
        path: paths.profileTeamGroups
      },
      {
        render: (props) => <ThemesPage deleted={props.match.params.filter === 'deleted'} {...props} />,
        path: paths.profileTeamThemes + '/:filter?'
      },
      {
        render: (props) => <SettingsPage {...props} />,
        path: paths.profileSettings
      },
      {
        render: (props) => <ApiPage {...props} />,
        path: paths.profileApi
      },
      {
        render: (props) => <TeamWebhooksPage {...props} />,
        path: paths.profileWebhooks
      },
      {
        render: (props) => <CustomiseEditorPage {...props} />,
        path: paths.profileCustomiseEditor
      },
      {
        render: (props) => <LayoutEditor setNavActions={setNavActions} {...props} />,
        path: paths.createLayout
      },
      {
        render: (props) => <LayoutEditor setNavActions={setNavActions} {...props} />,
        path: paths.editLayout
      },
      {
        render: (props) => <TableEditor setNavActions={setNavActions} {...props} />,
        path: paths.createTable
      },
      {
        render: (props) => <TableEditor setNavActions={setNavActions} {...props} />,
        path: paths.editTable
      },
      team && (team.in_beta || team.beta_features?.includes(2))
        ? {
            render: (props) => <AnalyticsPage {...props} />,
            path: paths.analytics
          }
        : null
    ],
    true,
    false
  );

  return (
    <>
      {profilePages}

      {config.billing.enabled &&
        generateRoutes(
          user,
          teams,
          team,
          toggleMenu,
          loading,
          [paths.profileSubscription],
          (props) => <SubscriptionPage team={team} subscription={subscription} {...props} />,
          true,
          false,
          paths
        )}

      <Route exact={true} path={paths.frontPage}>
        <Redirect to={paths.profileCharts} />
      </Route>
    </>
  );
}
